/**
 * Team / agent management APIs.
 */
import { apihubDelete, apihubGet, apihubPost } from "./apihub";

export function fetchProjectAgents(projectId) {
  return apihubGet(`/getInteractedCustomerDetail/fetchagent/${projectId}`);
}

export function fetchProjectForTeams(projectId) {
  return apihubGet(`/getInteractedCustomerDetail/projects/${projectId}`);
}

export function createAgent(payload) {
  return apihubPost("/getInteractedCustomerDetail/create-agents", payload);
}

export function editAgent(payload) {
  return apihubPost("/getInteractedCustomerDetail/edit-agents", payload);
}

export function deleteAgent(agentId) {
  return apihubDelete(`/getInteractedCustomerDetail/deleteteam/${agentId}`);
}
